/**
 * Page-number strip for a table footer: all pages when few, otherwise
 * 1 … around current … last (e.g. 1 … 4 5 6 … 20). Pages are 1-based.
 */
export function pageItems(current: number, total: number): (number | '…')[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
  const pages = new Set<number>([1, total])
  for (let p = current - 1; p <= current + 1; p++) {
    if (p >= 1 && p <= total) pages.add(p)
  }
  const sorted = [...pages].sort((a, b) => a - b)
  const items: (number | '…')[] = []
  let prev = 0
  for (const p of sorted) {
    if (prev !== 0 && p - prev === 2) items.push(prev + 1)
    else if (prev !== 0 && p - prev > 2) items.push('…')
    items.push(p)
    prev = p
  }
  return items
}
